import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "menuIcon", "closeIcon"]

  toggle() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.toggle("hidden")

      // Toggle icons
      if (this.hasMenuIconTarget && this.hasCloseIconTarget) {
        this.menuIconTarget.classList.toggle("hidden")
        this.closeIconTarget.classList.toggle("hidden")
      }
    }
  }

  close() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")

      // Show menu icon, hide close icon
      if (this.hasMenuIconTarget && this.hasCloseIconTarget) {
        this.menuIconTarget.classList.remove("hidden")
        this.closeIconTarget.classList.add("hidden")
      }
    }
  }
}
